import { render } from "./OrganizationalChart.vue?vue&type=template&id=f5027be6"
import script from "./OrganizationalChart.vue?vue&type=script&lang=js"
export * from "./OrganizationalChart.vue?vue&type=script&lang=js"

import "./OrganizationalChart.vue?vue&type=style&index=0&id=f5027be6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__